export default {
  menu: 'Agendamentos do Sistema',
  title: 'Agendamentos do Sistema',
  description: 'Configure tarefas automáticas do sistema, definindo o que deve ser executado, quando deve rodar e como tratar novas tentativas em caso de falha.',
  labels: {
    new: 'Novo agendamento',
  },
  fields: {
    scheduleKey: 'Chave interna',
    name: 'Nome do agendamento',
    active: 'Ativo',
    ownerService: 'Serviço responsável',
    startAt: 'Início',
    endAt: 'Término',
    intervalEvery: 'Repetir a cada',
    intervalUnit: 'Unidade',
    weekdays: 'Dias da semana',
    monthDay: 'Dia do mês',
    yearMonth: 'Mês do ano',
    targetScope: 'Tipo de destino',
    targetProduct: 'Produto',
    targetService: 'Serviço',
    targetDomain: 'Domínio',
    targetModule: 'Módulo',
    targetMethod: 'Operação',
    payload: 'Parâmetros da tarefa',
    maxOccurrences: 'Limite de execuções (0 = sem limite)',
    retryMaxAttempts: 'Máximo de tentativas',
    retryBackoffSeconds: 'Intervalo entre tentativas (s)',
    timeoutSeconds: 'Timeout (s)',
    targetOperation: 'Operação de destino',
    recurrenceType: 'Recorrência',
    recurrence: 'Regra de recorrência',
    timezone: 'Fuso horário',
    status: 'Status',
    nextRunAt: 'Próxima execução',
    lastRunAt: 'Última execução',
    lastRunStatus: 'Último resultado',
    consecutiveFailures: 'Falhas consecutivas',
    triggerType: 'Disparo',
    plannedAt: 'Execução prevista',
    currentAttempt: 'Tentativa',
    finishedAt: 'Concluída em',
    errorCode: 'Código do erro',
  },
  placeholders: {
    payload: 'Opcional. Use JSON somente quando a tarefa exigir parâmetros.',
  },
  intervalUnits: {
    minute: 'Minuto(s)',
    hour: 'Hora(s)',
    day: 'Dia(s)',
    week: 'Semana(s)',
  },
  weekdayNames: {
    mon: 'Seg',
    tue: 'Ter',
    wed: 'Qua',
    thu: 'Qui',
    fri: 'Sex',
    sat: 'Sáb',
    sun: 'Dom',
  },
  months: {
    january: 'Janeiro',
    february: 'Fevereiro',
    march: 'Março',
    april: 'Abril',
    may: 'Maio',
    june: 'Junho',
    july: 'Julho',
    august: 'Agosto',
    september: 'Setembro',
    october: 'Outubro',
    november: 'Novembro',
    december: 'Dezembro',
  },
  form: {
    title: 'Novo agendamento do sistema',
    groups: {
      schedule: 'Agendamento',
      task: 'Tarefa a executar',
      advanced: 'Opções avançadas',
    },
  },
  targetScopes: {
    shared: 'Serviço compartilhado',
    product: 'Serviço de produto',
  },
  actions: {
    history: 'Histórico',
    historyTooltip: 'Consultar o histórico de execuções',
    runNow: 'Executar agora',
    runNowTooltip: 'Solicitar uma execução manual imediatamente',
    pause: 'Pausar',
    pauseTooltip: 'Suspender novas execuções automáticas',
    resume: 'Reativar',
    resumeTooltip: 'Retomar as execuções automáticas',
  },
  confirmations: {
    runNowTitle: 'Executar agora',
    runNow: 'Executar este agendamento agora? A execução será registrada como manual e não altera a próxima execução automática.',
    pauseTitle: 'Pausar agendamento',
    pause: 'Pausar as próximas execuções automáticas deste agendamento?',
    resumeTitle: 'Reativar agendamento',
    resume: 'Reativar as execuções automáticas deste agendamento?',
  },
  history: {
    title: 'Histórico de execuções',
    empty: 'Ainda não existem execuções registradas para este agendamento.',
    limitNotice: 'Exibindo até 50 execuções mais recentes.',
  },
  messages: {
    runNowQueued: 'Execução manual adicionada à fila.',
    paused: 'Agendamento pausado.',
    resumed: 'Agendamento reativado.',
    operationError: 'Não foi possível concluir a operação no agendamento.',
    historyError: 'Não foi possível carregar o histórico de execuções.',
  },
  errors: {
    schedule_id_invalid: 'O identificador do agendamento é inválido. Atualize a página e tente novamente.',
    schedule_target_service_invalid: 'Selecione um serviço válido para a tarefa.',
    schedule_target_domain_invalid: 'Selecione um domínio válido para a tarefa.',
    schedule_target_module_invalid: 'Selecione um módulo válido para a tarefa.',
    schedule_target_method_invalid: 'Selecione uma operação válida para a tarefa.',
    schedule_target_product_required: 'Selecione o produto de destino.',
    schedule_start_at_invalid: 'Informe um início válido.',
    schedule_end_at_invalid: 'Informe um término válido.',
    schedule_end_before_start: 'O término deve ser posterior ao início.',
    schedule_weekdays_required: 'Selecione pelo menos um dia da semana.',
    schedule_month_day_invalid: 'Informe um dia do mês entre 1 e 31.',
    schedule_payload_invalid: 'Os parâmetros da tarefa precisam ser um objeto JSON válido.',
    schedule_update_forbidden: 'Este agendamento não pode mais ser alterado.',
  },
};
